import axios from '../utils/axios';

export function getUnmappedRecruiters(adminId, params) {
    return axios.get(`/admin/${adminId}/get-active-unverified-recruiters`, { params });
};
